module.exports = __webpack_public_path__ + "img/9788901129129.9d596d10.jpg";